import React, { Component } from "react";
import { injectIntl } from "react-intl";
import orderActions from "../../actions/order";
import { connect } from "react-redux";
import Wrapper from "../LandingBlockWrapper/BlockWrapper";
import { Collapse, Col, Row, Spin, Icon, List, Avatar, Checkbox } from "antd";

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin/>;
const Panel = Collapse.Panel;


const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

class CheckBox extends Component{
	constructor(props) {
		super(props);
		this.state = {
			checked: null,
		};
	}
	
	componentDidMount() {
		this.setState({
			checked: this.props.checked
		});
	}
	
	onCheckChange = (e) => {
		const checked = e.target.checked;
		orderActions.checkOrders(this.props.orderEmail, checked);
		this.setState({
			checked
		});
	};
	
	render() {
		const { checked } = this.state;
		return <Checkbox onChange={this.onCheckChange} checked={checked}/>;
	}
}

class Admin extends Component{
	constructor(props) {
		super(props);
		this.state = {
			defaultCheckedList: [],
			checkAll: false,
			checked: null,
			ordersListMap: {},
			ordersListKeys: [],
		};
	}
	
	componentWillMount() {
		orderActions.getOrders();
	}
	
	componentWillReceiveProps() {
		this.createOrdersList(this.props.orders);
	}
	
	twoDigits = (data) => {
		if (data < 10) {
			return `0${data}`;
		}
		return data;
	};
	formatDate = (date) => {
		const newDate = new Date(date);
		const month = newDate.getMonth();
		const day = newDate.getDate();
		const hour = newDate.getHours();
		const minute = newDate.getMinutes();
		const dateString = `${this.twoDigits(day)}.${this.twoDigits(month)}.${newDate.getFullYear()} ${this.twoDigits(hour)}:${this.twoDigits(minute)}`;
		
		return dateString;
	};
	createOrdersList = (orders) => {
		let ordersListMap = {};
		orders.forEach((item) => {
			let date = new Date(item.registrationDate);
			if (ordersListMap[date.getMonth()]) {
				ordersListMap[date.getMonth()].push(item);
			} else {
				ordersListMap[date.getMonth()] = [item];
			}
		});
		this.setState({
			ordersListKeys: Object.keys(ordersListMap),
			ordersListMap: ordersListMap
		});
	};
	
	render() {
		const { ordersIsLoading } = this.props;
		const { ordersListMap, ordersListKeys } = this.state;
		
		if (ordersIsLoading) {
			return (
				<Row type="flex" justify="center" align="middle" className="Spin">
					<Spin indicator={antIcon}/>
				</Row>
			);
		}
		return <div style={{ height: "100vh" }}>
			<Wrapper className="Collapse">
				<h2>Orders</h2>
				<Collapse bordered={false} onChange={this.handleChange} className="Admin">{
					ordersListKeys.map((quest, i) => {
						return <Panel header={months[quest]} key={i} className="customPanelStyle">
							<List
								itemLayout="horizontal"
								dataSource={ordersListMap[quest]}
								renderItem={item => (
									<List.Item actions={[<CheckBox checked={item.checked} orderEmail={item.email}/>]}>
										<Row className="item">
											<Col xs={{ span: 3 }} sm={{ span: 2 }} className="avatar"><Avatar
												src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"/></Col>
											<Col xs={{ span: 24 }} sm={{ span: 22 }} className="describe">
												<Col xs={{ offset: 0, span: 22 }} sm={{ offset: 2, span: 18 }}
												     md={{ offset: 2, span: 12 }}>
													<Row span={6}>{`User UID: ${item.uid}`}</Row>
													<Row span={6}>{`Ordered at ${this.formatDate(item.registrationDate)}`}</Row>
												</Col>
												<Col xs={{ offset: 0, span: 22 }} sm={{ offset: 2, span: 18 }}
												     md={{ offset: 2, span: 8 }}>
													{`User EMAIL: ${item.email}`}
												</Col>
											</Col>
										</Row>
									</List.Item>
								)}
							/>
						</Panel>;
					})
				}
				</Collapse>
			</Wrapper>
		</div>;
	}
}

const mapStateToProps = ({ order: { orders, ordersIsLoading } }) => {
	return { orders, ordersIsLoading };
};

export default connect(mapStateToProps)(injectIntl(Admin));


// WEBPACK FOOTER //
// ./src/components/Admin/Admin.js